module.exports = __webpack_public_path__ + "static/media/poll-people.753cb3bc.svg";